import { render, staticRenderFns } from "./UpcomingAssignmentWidget.vue?vue&type=template&id=8d04c93e&scoped=true&"
import script from "./UpcomingAssignmentWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingAssignmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingAssignmentWidget.vue?vue&type=style&index=0&id=8d04c93e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04c93e",
  null
  
)

export default component.exports